import React, { useMemo } from 'react'
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable'
import { ENDPOINT } from '../../services/endPoints'
import { useSearchParams } from 'react-router-dom'

const NurseDetailsView = () => {
   
    const [searchParams] = useSearchParams();
    const nurse_id =  searchParams.get("nurses_id") 

    const callTypeValues = useMemo(()=>{
        if(!!searchParams.get("total_referred_tests")===true){
            return `?nurses_id=${nurse_id}&form_type=null&form_accept_reject=null`
        } else if(!!searchParams.get("Foot_Forms")===true){
            return `?nurses_id=${nurse_id}&form_type=1&form_accept_reject=null`
        }else if(!!searchParams.get("Eye_Forms")===true){
            return `?nurses_id=${nurse_id}&form_type=2&form_accept_reject=null`
        }else if(!!searchParams.get("Rejected_forms")===true){
            return `?nurses_id=${nurse_id}&form_type=null&form_accept_reject=2`
        }
    },[searchParams, nurse_id])


    const excludedKeys = ['id', 'form_viewed',  'year', 'doctore_comments1', 'doctore_comments2', 'form_filling_Date', 'doctore_comments3', "createdAt", "updatedAt", "deletedAt",
    "patient_DOB","form_code","hospital_region" ,"patient_code","patient_cmis_id","facility_type","nurses_region","pf_id",
    "nurses_id","hospital_id", "form_accept_reject","patient_gender"];
    
      const compareValue = [
    "id",
    "patient_name",
    "patient_age",
    "patient_DOB",
    "patient_natinal_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "facility_name",
    "facility_type",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "form_accept_reject",
    "doctore_comments1",
    "doctore_comments2",
    "doctore_comments3",
    "form_viewed",
    "form_filling_Date",
    "form_code",
    "form_type",
    "form_risk_rating",
    "createdAt",
    "updatedAt",
    "deletedAt",
    "pf_id",
    "nurses_id",
    "nurse_name",
    "hospital_id",
    ];
    
      const customKeyName = {
        "patient_name": "Name",
        "patient_age": "Age",
        "patient_natinal_id": "Natinal ID",
        "facility_name": "Facility Name",
        "hospital_Name": "Referred Facility",
        "nurse_name": "Nurse Name",
        "form_accept_reject": "Accept/Reject",
        "form_viewed": "Form Viewed",
        "form_type": "Form Type",
        "form_risk_rating": "Risk Rating",
    
      }
    
      const customWidth = {
        patient_name: "120px",
        patient_age: "30px",
        patient_natinal_id: "200px",
        facility_name: "150px",
        hospital_Name: "150px",
        form_viewed: "100px",
      }

  return (
    <>
         <CustomDataTable 
                tableTitle={"Nurse Performance"}
                endPoint={`${ENDPOINT.NURSE_DETAILS_FILTER}${callTypeValues}`}
                filterKey={"patient_name"}
                excludedKeys={excludedKeys}
                customKeyName={customKeyName}
                compareValue={compareValue}
                customWidth={customWidth}
                customQueryParam={callTypeValues}
                />
    </>
  )
}

export default NurseDetailsView